import { faMinus, faSortAlphaDown, faSortAlphaUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReportSortDirectionType } from 'peekdata-datagateway-api-sdk';
import React from 'react';
export var SortButton = function (_a) {
    var sorting = _a.sorting;
    return (React.createElement("i", null,
        React.createElement(FontAwesomeIcon, { icon: getIcon(sorting) })));
};
var getIcon = function (sorting) {
    switch (sorting) {
        case ReportSortDirectionType.ASC:
            return faSortAlphaDown;
        case ReportSortDirectionType.DESC:
            return faSortAlphaUp;
        default:
            return faMinus;
    }
};
